import React from 'react';

import { List, Datagrid, FilterForm } from 'components/list';
import { TextField, BooleanField } from 'components/field';
import { EditButton } from 'components/button';

import {
  COUNTRY_VN,
} from 'util/constants';

import * as urls from './urls';
import * as utils from './utils';


function PriceField({ record={}, source, label }) {
  const isVnBuyDevice = process.env.REACT_APP_COUNTRY === COUNTRY_VN && record.category === utils.BUY_SUNMI_DEVICE;
  const newRecord = {...record, [source]: isVnBuyDevice ? 'by formula' : record[source]};
  return <TextField record={newRecord} source={source} label={label} />
}


const CategoryField = (props) => {
    const { source, record } = props;
    const newRecord = {
      [source]: utils.PRODUCT_CATEGORY_NAME[record[source]]
    };
    return (
      <TextField {...props} record={newRecord}/>
    );
  }
;

export const ProductList = (props) => (
  <List hasCreate={true} filters={<FilterForm/>} {...props}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="id" label="ID"/>
      <CategoryField source="category" label="Category"/>
      <TextField source="denomination" label="Denomination"/>
      <TextField source="en" label="Name"/>
      <TextField source="translation" label="Name(Local)"/>
      <TextField source="description_en" label="Description"/>
      <TextField source="description_translation" label="Description(Local)"/>
      <PriceField source="price" label="Price" />
      <PriceField source="price_en" label="Price Display"/>
      <PriceField source="price_translation" label="Price Display(Local)"/>
      <TextField source="sequence" label="Sequence"/>
      <BooleanField source="is_active" label="Status"/>
      <EditButton linkTo={urls.productEditFrontendPath} label="Edit"/>
    </Datagrid>
  </List>
);


// WEBPACK FOOTER //
// ./src/routes/product/ProductList.js